export class CloudrunHealth {
  public static PLATFORM = 'Cloud Run Service';
}
